/**
 * <s-share> — product share control, matching Refresh's share button behaviour.
 *
 * Where the browser supports the Web Share API (navigator.share), the summary opens
 * the native share sheet. Otherwise the <details> opens to show the product link with
 * a copy button (navigator.clipboard).
 *
 * Required markup:
 *   details > summary              — "Teilen" trigger.
 *   input[data-share-url]          — readonly input holding the product URL.
 *   button[data-share-copy]        — copies the URL.
 *   [data-share-status]            — live region for the copy confirmation (hidden until copied).
 */
class SShare extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.querySelector('summary')?.addEventListener('click', (event) => {
      if (typeof navigator.share !== 'function') return;
      event.preventDefault();
      const url = this.querySelector('input[data-share-url]')?.value || document.location.href;
      navigator.share({ url, title: document.title }).catch(() => {});
    }, opts);

    this.querySelector('button[data-share-copy]')?.addEventListener('click', async () => {
      const input = this.querySelector('input[data-share-url]');
      const status = this.querySelector('[data-share-status]');
      if (!(input instanceof HTMLInputElement)) return;

      try {
        await navigator.clipboard.writeText(input.value);
        if (status instanceof HTMLElement) status.hidden = false;
      } catch (error) {
        input.select();
      }
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-share')) {
  customElements.define('s-share', SShare);
}
